import { useState, useEffect, useCallback } from 'react'
import { appsyncQuery } from '../api/appsync-client.js'

const LIST_INVITATIONS = `
  query ListInvitations {
    listInvitations {
      managerId managerName managerEmail invitedAt
    }
  }
`

const APPROVE_INVITATION = `
  mutation ApproveInvitation($managerId: ID!) {
    approveInvitation(managerId: $managerId) {
      managerId status createdAt managerName managerEmail
    }
  }
`

const DECLINE_INVITATION = `
  mutation DeclineInvitation($managerId: ID!) {
    declineInvitation(managerId: $managerId)
  }
`

export function useInvitations({ enabled = true } = {}) {
  const [invitations, setInvitations] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    if (!enabled) return
    setLoading(true)
    setError(null)
    try {
      const data = await appsyncQuery(LIST_INVITATIONS)
      setInvitations(data.listInvitations)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [enabled])

  useEffect(() => { load() }, [load])

  const approve = useCallback(async (managerId) => {
    const data = await appsyncQuery(APPROVE_INVITATION, { managerId })
    const result = data.approveInvitation
    await load()
    return result
  }, [load])

  const decline = useCallback(async (managerId) => {
    await appsyncQuery(DECLINE_INVITATION, { managerId })
    await load()
  }, [load])

  return { invitations, loading, error, approve, decline }
}
